import { cn, Icon, Typography } from "@kyan/ui";

import { type ChangeIndicatorValues } from "#/types/combo";
import { formatPercent, formatValue } from "#/utils/valueFormatters";

export interface ChangeIndicatorProps extends ChangeIndicatorValues {
  template?: string;
  withExtraSpace?: boolean;
  leftLabelClassName?: string;
  rightLabelClassName?: string;
  isPercent?: boolean;
  signDisplay?: Intl.NumberFormatOptions["signDisplay"];
}

export const ChangeIndicator: React.FC<ChangeIndicatorProps> = ({
  from,
  to,
  template = "0",
  withExtraSpace = false,
  leftLabelClassName,
  rightLabelClassName,
  isPercent = false,
  signDisplay = "auto",
}) => {
  const formatDisplayValue = isPercent ? formatPercent : formatValue;

  return (
    <div className="text-textPrimary flex items-center gap-1.5 text-xs">
      <Typography className={leftLabelClassName}>
        {formatDisplayValue(from, {
          template,
          trailingZeroDisplay: "stripIfInteger",
          signDisplay,
        })}
      </Typography>

      <Icon
        size="xs"
        name="arrow-up"
        className="text-textSecondary rotate-90"
      />

      <div className={cn("flex", { "w-10 justify-end": withExtraSpace })}>
        <Typography className={rightLabelClassName}>
          {formatDisplayValue(to, {
            template,
            trailingZeroDisplay: "stripIfInteger",
            signDisplay,
          })}
        </Typography>
      </div>
    </div>
  );
};
